<script lang="ts" setup>
import { navigateToUrl } from 'single-spa';
import { computed, inject } from 'vue';

import { BreadcrumbProps } from './Breadcrumb.vue.d';
import useBreadcrumbStore from './store';

const props = defineProps<BreadcrumbProps>();

const { breadcrumbs } = useBreadcrumbStore();

const Preset = inject<Record<string, any>>('preset', {}).breadcrumb;

const menus = computed(() =>
  props.menus?.length ? props.menus : breadcrumbs.value,
);

const lastIndex = computed(() => menus.value.length - 1);
</script>

<template>
  <div v-bind="Preset.root">
    <template :key="menu.route" v-for="(menu, index) in menus">
      <span
        v-bind="
          Preset.item({
            context: {
              firstItem: index == 0,
              lastItem: index == lastIndex,
              hasRoute: !!menu.route,
            },
          })
        "
      >
        <a
          v-if="menu.route"
          :href="menu.route"
          :title="menu.title"
          v-bind="Preset.itemlink"
          @click="navigateToUrl(menu.route!)"
        >
          {{ menu.name }}
        </a>

        <template v-else>
          {{ menu.name }}
        </template>
      </span>

      <span
        v-if="index != lastIndex"
        v-text="Preset.separator.content"
        v-bind="Preset.separator"
      />
    </template>
  </div>
</template>
